import './index.scss'
$("header .nav li").eq(2).addClass("active");
$(".nei-nav ul li").eq(0).addClass("active");